import { Pipe, PipeTransform } from '@angular/core';
import { DATE_FORMAT } from '@common/const/form.constants';

import * as dayjs from 'dayjs';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

@Pipe({
  standalone: true,
  name: 'tmwDate',
})
export default class TmwDatePipe implements PipeTransform {
  transform(day: any): string {
    if (!day) {
      return '';
    }

    const parsedDay = typeof day === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(day)
      ? dayjs(day, DATE_FORMAT, true)
      : dayjs(day);

    return parsedDay.isValid() ? parsedDay.format(DATE_FORMAT) : '';
  }
}
